export default String.raw`
.search-advanced-container {
    display: flex;
    width: 100%;
    padding: 0 9%;
    flex-direction: column;
    user-select: none;

    strong {
        color: $dangerColor;
        font-size: 12px;
        font-weight: 400;
    }

    &__search {
        display: grid;
        grid-template-columns: 5fr 2fr;
        $height: 40px;
        width: 60%;
        margin-bottom: 40px;

        &-phrase {
            position: relative;

            &-delete {
                position: absolute;
                width: 18px;
                height: 18px;
                fill: $inputsBorderColor;
                right: 14px;
                top: 11px;
                cursor: pointer;
            }

            &-input {
                height: $height;
                appearance: none;
                padding: 0 3em 0 1em;
                font-size: 14px;
                border: 1px solid $inputsBorderColor;
                border-radius: 5px 0 0 5px;
                width: 100%;
    
                &::-webkit-search-cancel-button {
                    display: none;
                }
            }
        }

        &-categories {
            font-size: 14px;

            div {
                height: $height;
                border: 1px solid $inputsBorderColor;
                border-left: none;
                border-radius: 0 5px 5px 0;
                padding: 0 16px;

                svg {
                    width: 14px;
                    height: 14px;
                    fill: $inputsBorderColor;
                }
            }
        }
    }

    h4 {
        margin: 0 0 24px 0;
        font-size: 1rem;
    }

    &__find-by {
        display: flex;
        flex-direction: column;
        row-gap: 16px;
        margin-bottom: 40px;

        label {
            font-size: 14px;
            width: fit-content;
        }
    }

    &__price {
        position: relative;

        strong {
            position: absolute;
            top: -22px;

            &.hidden {
                visibility: hidden;
            }
        }

        div {
            display: flex;
            align-items: baseline;
            margin-bottom: 40px - 24px;
        }

        fieldset {
            display: flex;
            justify-content: space-between;
            align-items: center;
            width: 140px;
            height: calc(40px + 12px);
            border: 1px solid $inputsBorderColor;
            border-radius: 5px;
            padding-top: 0;
            padding-bottom: 0;
            padding-right: 0;

            span {
                font-size: 12px;
                position: relative;
                bottom: 6px;
            }

            input {
                border: none;
                width: 75%;
                height: 100%;
                font-size: 14px;
                position: relative;
                bottom: 6px;
            }

            legend {
                font-size: 12px;
                color: $inputsBorderColor;
            }
        }

        span {
            font-size: 12px;
            position: relative;
            bottom: 6px;
            margin: 0 0.5em;
        }
    }

    &__checkboxes {
        display: grid;
        grid-template-columns: repeat(3, auto);
        width: 60%;
        justify-content: space-between;
        column-gap: 1em;

        h4 {
            grid-column: 3 span;
            margin: 24px 0;
        }

        &-two-columns:nth-child(2n + 1) {
            grid-column: 2 span;
        }

        h2:first-child {
            margin-top: 0;
        }

        label {
            margin-bottom: 16px;
            font-size: 14px;
            width: fit-content;
        }
    }

    &__buttons {
        display: flex;
        column-gap: 24px;
        row-gap: 8px;
        align-self: end;
        margin: 16px 0 32px 0;
    }
}
`